import TRANSLATE from "./constants";
const CryptoJS = require("crypto-js");

class Utils {
  noMoreThanNCharacters = (n) => {
    return TRANSLATE.FORM.NO_MORE_THAN_N_CHARACTERS.replace("%n%", n);
  };

  arrayFilter = (array, params) => {
    let filter = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => v !== "")
    );
    return array.filter(function (item) {
      for (var key in filter) {
        if (
          item[key] === undefined ||
          item[key] === null ||
          item[key]
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .search(filter[key] != null ? filter[key].toLowerCase() : "") === -1
        )
          return false;
      }
      return true;
    });
  };

  getFormattedDateMMddyyyy = (date, separator) => {
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");

    return month + separator + day + separator + year;
  };

  getFormattedDateyyyyMMdd = (date, separator) => {
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");

    return year + separator + month + separator + day;
  };

  convertStringEmptyToNull = (obj) => {
    Object.keys(obj).forEach(function (key) {
      if (obj[key] === "") {
        obj[key] = null;
      }
    });
    return obj;
  };

  getNumberOfValidFields = (obj) => {
    let quantity = 0;
    Object.keys(obj).forEach(function (key) {
      if (obj[key]) {
        quantity++;
      }
    });
    return quantity;
  };

  clearChildren = (element) => {
    for (var i = 0; i < element.childNodes.length; i++) {
      var e = element.childNodes[i];
      if (e.tagName)
        switch (e.tagName.toLowerCase()) {
          case "input":
            switch (e.type) {
              case "radio":
              case "checkbox":
                e.checked = false;
                break;
              case "button":
              case "submit":
              case "image":
                break;
              default:
                e.value = "";
                break;
            }
            break;
          case "select":
            e.selectedIndex = 0;
            break;
          case "textarea":
            e.innerHTML = "";
            break;
          default:
            this.clearChildren(e);
        }
    }
    return false;
  };

  encrypt = (text) => {
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
  };

  decrypt = (data) => {
    return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
  };

  validationPermissions = (rol) => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === rol);
    return module;
  };

  convertToDateddMMyyyy = (stringDate) => {
    var removeTime = stringDate.split(" ")[0];
    var from = removeTime.split("/");
    var f = new Date(from[2], from[1] - 1, from[0]);
    return f;
  };

  padLeadingZeros = (num, size) => {
    var s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  };

  convertObjectToKeyNameObject = (obj) => {
    var data = [];
    Object.entries(obj).map((item) => {
      const key = item[0];
      const value = item[1];
      data.push({ key, value });
    });
    return data;
  };

  replaceTextDynamicClauses(input) {
    const regex = /@\[(.*?)\]\(.*?\)/g;

    const result = input.replace(regex, (match, p1) => p1);

    return result;
  }
}

export default new Utils();
